import { clone } from '../../object/clone';
import { mapper } from '../mapper';
import { mapDictionaryFactory } from '../mappers/dictionary/mapDictionaryFactory.js';
import { mapSchemaFactory } from '../mappers/schema/mapSchemaFactory';
import { createSchemaDictionary } from '../schemaToDictionary/createSchemaDictionary';

export function mergeViewSchema(viewJson, schemaJson, options) {
  const dictionary = createSchemaDictionary(schemaJson);

  /**
   * Necesitamos hacer eso en vez de simplemente esta linea:
   *  ->    const viewMerged = mapper(viewJson, mapDictionaryFactory(viewJson), mapSchemaFactory(schemaJson, options));
   * para poder saltar el primer property (el root, el view)
   * para que sea retrocompatible, bueno, exactamente igual que con el flatmap que saltaba el root
   *
   * INI
   */
  const viewMerged = clone(viewJson);
  if (Array.isArray(viewJson.properties)) {
    const mapDictionary = mapDictionaryFactory(viewJson);
    const mapSchema = mapSchemaFactory(schemaJson, options);

    viewMerged.properties = viewJson.properties.map(property => {
      return mapper(property, mapDictionary, mapSchema);
    });
  }
  /**
   * FIN
   */

  viewMerged.order = dictionary.__order;

  return viewMerged;
}
